type ControlledPostEditCTAProps = {
  isVisible: boolean;
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
};

export const ControlledPostEditCTA: React.FC<ControlledPostEditCTAProps> = ({
  isVisible,
  startContent,
  endContent,
}) => {
  if (isVisible) {
    return (
      <div className="flex flex-col flex-wrap border-b-1 border-b-gray-200 bg-gray-100 p-xs md:flex-row md:items-center">
        <div className="flex flex-1 justify-start">{startContent}</div>
        <div className="flex justify-end">{endContent}</div>
      </div>
    );
  }

  return null;
};
